export default __webpack_public_path__ + "static/media/017-turn-right-2.709025a7.png";